<template>
  <BaseWarning>
    <i18n path="warnings.unsuitableStyle.warning" tag="span">
      <template #style>{{ $t(`tactics.${data.style}Style`) }}</template>
      <template #selectedStyle>{{ $t(`tactics.${data.style}Styles.${data.selectedStyle}`) }}</template>
      <template #suitability>{{ data.suitability.toFixed(1) }}</template>
    </i18n>
  </BaseWarning>
</template>

<script>
import BaseWarning from "./BaseWarning.vue";

export default {  
  props: {
    data: Object
  },

  components: { BaseWarning },
};
</script>
